import { Observable } from 'rxjs';

/**
 * Emits the last ResizeObserverEntry for each ResizeObserver callback.
 *
 * @param el Target element to observe.
 * @returns Observable emitting the latest ResizeObserverEntry per callback.
 */
export function observeResize(el: Element): Observable<ResizeObserverEntry> {
  return new Observable<ResizeObserverEntry>((subscriber) => {
    const ro = new ResizeObserver((entries) => {
      const last = entries[entries.length - 1];
      if (last) subscriber.next(last);
    });

    ro.observe(el);

    return () => ro.disconnect();
  });
}
